import React from 'react';
import { NextButton } from '../../../../../common/buttonsComponents';

const SearchPageNextButton = (props) => {
  if (props.isHidden) {
    return null;
  }

  return <NextButton {...props} />;
};

export default SearchPageNextButton;
